export default __webpack_public_path__ + "static/media/gym-bg-02.44402d35.jpg";